import React from "react";
import InputWithDropDown from "./InputWIthDropDown";
import type { EmailOption } from "../EmailContext";

function InputForEmail({
  name,
  needCCAndBCC,
  setShowCC,
  setShowBCC,
  showBCC,
  showCC,
  emails,
  handleChange,
  fetchOptions,
}: {
  name: string;
  needCCAndBCC?: boolean;
  setShowCC?: React.Dispatch<React.SetStateAction<boolean>>;
  setShowBCC?: React.Dispatch<React.SetStateAction<boolean>>;
  showBCC?: boolean;
  showCC?: boolean;
  emails: EmailOption[];
  handleChange: (
    emails: EmailOption[] | ((prev: EmailOption[]) => EmailOption[])
  ) => void;
  fetchOptions: (currentEmail: string) => Promise<EmailOption[]>;
}) {
  return (
    <div className="container-receipts">
      <label className="block text-sm font-medium">{name}</label>

      <InputWithDropDown
        emails={emails}
        setEmails={handleChange}
        fetchOptions={fetchOptions}
      />
      {needCCAndBCC && !showBCC ? (
        <button
          className="btn-mail-editor"
          onClick={() => setShowBCC?.((prev) => !prev)}
        >
          Bcc
        </button>
      ) : null}
      {needCCAndBCC && !showCC ? (
        <button
          className="btn-mail-editor"
          onClick={() => setShowCC?.((prev) => !prev)}
        >
          Cc
        </button>
      ) : null}
    </div>
  );
}

export default InputForEmail;
